import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Header from '../Header/Header';
import { CustomTable, ConfirmationPopup, SuccessModal, Pagination, Search, ReschedulePopup, Loader, ICONS, Icon } from '@ohif/ui';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _commonUrls } from '@custom/Utils/constants/apiUrls';
import { DatePickerWithRange } from '@ohif/ui-next';
import { servicesManager } from '../../app/src/App';
import { capitalizeWords, customStyle, formatDate, formattedDate } from '@custom/Utils/utils';
import { useTheme } from "../../ui/src/contextProviders"
import { AppDispatch, RootState } from '@custom/store/store';
import changeDiscountStatusApi from '@custom/rtk-apis/billing/discountNotification/changeDiscountStatus';
import { _roleType } from '@custom/Utils/constants/appConstants';
import getInvoiceDiscountRequestApi from '@custom/rtk-apis/billing/doctorDiscount/invoiceWithDiscountRequest';

const columns = [
  { key: 'name', title: 'Patient Name',sort:true },
  { key: 'patientId', title: 'Patient Id'},
  { key: 'requestedBy', title: 'Requested By' },
  { key: 'requestedAmount', title: 'Amount' },
  { key: 'invoiceNo', title: 'Invoice No'},
  { key: 'date', title:'Date',sort:true},
  { key: 'time', title:'Time',sort:true},
  { key: 'status', title:'Status'},
  { key: 'actions', title: 'Actions' },
];

const DiscountNotification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { isDarkMode } = useTheme();
  const { uiNotificationService } = servicesManager.services;

  const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);
  const getInvoiceDiscountRequestData = useSelector((state: RootState) => state.getInvoiceDiscountRequestResponse);

  const [modalityList, setModality] = useState([]);
  const [reportStatus, setReportStatus] = useState([]);
  const [moreActions, setMoreActions] = useState([]);
  const [filterData, setFilterData] = useState({
    status: [],
    modality: []
  });


  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModal] = useState(false);
  const [successModalText, setSuccessModalText] = useState('');
  const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);
  const [confirmationPopup, setConfirmationPopup] = useState({
    tite: '',
    message: '',
    discount: 0,
    invoice_id: ''
  })
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const buttonRef = useRef(null);
  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  // updatedDateTime state
  const [updatedDateTime, setUpdatedDateTime] = useState({
    date: '',
    time: '',
  });
  const [selectedRow, setSelectedRow] = useState(null);
  const [load, setLoad] = useState(true);

  const [searchQuery, setSearchQuery] = useState('');
  const [tableData, setTableData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [search, setSearch] = useState('');
  const [searchInputValue, setSearchInputValue] = useState('');
  const [pgNumber, setPgNumber] = useState(1);
  const [pgLimit, setPgLimit] = useState(30);
  const [totalPg, setTotalPg] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedCount, setSelectedCount] = useState(0);
  const formikRef = useRef(null);
  const [dateRange, setDateRange] = useState<{
    startDate: string | null;
    endDate: string | null
  }>({
    startDate: null,
    endDate: null
  });

  useEffect(() => {
    setLoad(true);
    dispatch(getInvoiceDiscountRequestApi({
      search,
      fromDate: startDate,
      toDate: endDate,
      page: pgNumber,
      limit: pgLimit
    }));
  }, [dispatch]);

  useEffect(() => {
    if (getInvoiceDiscountRequestData?.status === "success") {
      const data = getInvoiceDiscountRequestData?.result?.map((item) => ({
        name: capitalizeWords(item?.patientInfo?.firstName + ' ' + item?.patientInfo?.lastName),
        date: getDateFromTimestamp(item?.discountRequest?.requestedAt),
        time: getTimeFromTimestamp(item?.discountRequest?.requestedAt),
        requestedBy: capitalizeWords(item?.discountRequest?.requestedByName),
        requestedAmount: item?.discountRequest?.amount,
        patientId: item?.patientInfo?.patientId,
        invoiceNo: item?.invoiceNumber,
        status: capitalizeWords(item?.discountRequest?.status),
        invoice_id: item?._id,
      }));
      setTableData(data);
      setTotalPg(Math.max(1, Math.ceil(getInvoiceDiscountRequestData?.pagination?.total)));
    }
    setLoad(false);
  }, [getInvoiceDiscountRequestData, pgLimit, dispatch]);

  const checkCanApproveDiscount = () => {
    const userRole = localStorage.getItem('role') || sessionStorage.getItem('role');
    if(userRole === _roleType.admin || userRole === _roleType.superAdmin || userRole === _roleType.hospitalSuperadmin) return true;

    if(userRole === _roleType.frontDesk) {
      const storedApproval  = sessionStorage.getItem('canApproveDiscount') === 'true' || localStorage.getItem('canApproveDiscount') === 'true';
      return storedApproval ;
    }
    return false;
  }

  const onPageChangeHandler = pg => {
    setPgNumber(pg);
     dispatch(getInvoiceDiscountRequestApi({
      search,
      fromDate: startDate,
      toDate: endDate,
      page: pg,
      limit: pgLimit
    }));
  };
  const handlePageSizeChange = e => {
    setPgLimit(e);
     dispatch(getInvoiceDiscountRequestApi({
      search,
      fromDate: startDate,
      toDate: endDate,
      page: pgNumber,
      limit: e
    }));
  };

  const resetFilter = () => {
    setStartDate("");
    setEndDate("");
    setDateRange({
      startDate: null,
      endDate: null
    });
    setSearch("");
    setSearchInputValue("");
    setPgNumber(1);
    setFilterData({
      status: [],
      modality: []
    });
    setSelectedCount(0);
    if (formikRef.current) {
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('status', []);
      formikRef.current.setFieldValue('modality', []);
    }
    dispatch(
      getInvoiceDiscountRequestApi({
        search: '',
        fromDate: '',
        toDate: '',
        page: 1,
        limit: pgLimit,
      })
    );
  };

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      if (commonData?.status) {
        setModality(commonData?.result?.modality);
        setReportStatus(commonData?.result?.reportStatus);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchCommonData();
  }, []);

  const handleDateChange = (dates: { startDate: string, endDate: string }) => {
    const { startDate, endDate } = dates;

    if (startDate && endDate) {
      const formattedStartDate = formattedDate(startDate);
      const formattedEndDate = formattedDate(endDate);

      setDateRange({ startDate, endDate });
      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);

      setFilterData(prevValues => ({
        ...prevValues,
        Date: {
          startDate: formattedStartDate,
          endDate: formattedEndDate
        }
      }));

      if (formattedStartDate && formattedEndDate) {
        dispatch(getInvoiceDiscountRequestApi({
          search: search,
          fromDate: formattedStartDate,
          toDate: formattedEndDate,
          page: 1,
          limit: pgLimit
        }));
      }
    }
  };

  const filterFormInitialValue = {
    status: filterData?.status || [],
    modality: filterData?.modality || []
  }

  const handleResetForm = () => {
    setFilterData({
      status: [],
      modality: []
    });
    setIsFilterOpen(false);
    setSelectedCount(0);
    if (formikRef.current) {
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('status', []);
    }
  }

  let actions = [
    {
      label: 'Preview Invoice',
      iconName: 'preview',
      onClick: ((item) => {
        console.log('Preview Invoice clicked', item);
        navigate(`/invoice/preview/${item?.invoice_id}`);
      })
    },
    {
      label: 'Approve Discount',
      iconName: 'preview',
      onClick: ((item) => {
        console.log('Approve clicked', item);
        setIsPopupOpen(true);
        setConfirmationPopup({
          tite: 'Approve Discount',
          message: 'Enter discount amount:',
          discount: item?.requestedAmount,
          invoice_id: item?.invoice_id,
        });
      })
    },
    {
      label: 'Discard Discount',
      iconName: 'preview',
      onClick: ((item) => {
        console.log('Discard clicked', item);
        setIsCancelPopupOpen(true);
        setConfirmationPopup({
          tite: 'Discard Discount',
          message: 'Are you sure you want to discard this discount request?',
          discount: item?.requestedAmount,
          invoice_id: item?.invoice_id,
        });
      })
    },
  ];

  const handleCancel = () => {
    setIsPopupOpen(false);
  };

  const navigateToPage = () => {
    if (billingGeneralSettingsData?.msg === "General settings not found for this hospital.") {
      uiNotificationService.show({
        title: 'Billing Settings',
        message: 'Fill the general settings to create appointment.',
        type: 'error',
      });
      navigate('/billing');
    } else {
      navigate("/addappointment");
    }
  }


  const searchClick = searchText => {
    setSearch(searchText);
    setSearchInputValue(searchText);
    setPgNumber(1);
    dispatch(getInvoiceDiscountRequestApi({
      search: searchText,
      fromDate: startDate,
      toDate: endDate,
      page: 1,
      limit: pgLimit
    }));
  }

  const handleConfirmApprove = async () => {
    console.log('first', confirmationPopup);
    setLoad(true);
    try {
      const payload = {
        discountedPrice: confirmationPopup.discount,
        _id: confirmationPopup.invoice_id,
        status: "Approved"
      }
      const result = await dispatch(changeDiscountStatusApi(payload)).unwrap();
      if (result?.status === "success") {
        setIsSuccessModal(true);
        setSuccessModalText(result?.msg);
        setConfirmationPopup({
          tite: '',
          message: '',
          discount: 0,
          invoice_id: ''
        });
        setIsPopupOpen(false);
        dispatch(getInvoiceDiscountRequestApi({
          search,
          fromDate: startDate,
          toDate: endDate,
          page: pgNumber,
          limit: pgLimit
        }));
      }
    } catch (err) {
      console.error('Failed to update request status:', err);
      uiNotificationService.show({
        title: 'Error',
        message: 'Failed to update request status',
        type: 'error',
      });
    }
    finally {
      setLoad(false);
    }
  }

  const handleCancelDiscount = async () => {
    setLoad(true);
    try {
      const payload = {
        _id: confirmationPopup.invoice_id,
        status: "Rejected"
      }
      const result = await dispatch(changeDiscountStatusApi(payload)).unwrap();
      if (result?.status === "success" || result?.status === 'SUCCESS') {
        setIsSuccessModal(true);
        setSuccessModalText(result?.msg);
        setConfirmationPopup({
          tite: '',
          message: '',
          discount: 0,
          invoice_id: ''
        });
        setIsCancelPopupOpen(false);
        dispatch(getInvoiceDiscountRequestApi({
          search,
          fromDate: startDate,
          toDate: endDate,
          page: pgNumber,
          limit: pgLimit
        }));
      }
    } catch (err) {
      console.error('Failed to update request status:', err);
      uiNotificationService.show({
        title: 'Error',
        message: 'Failed to update request status',
        type: 'error',
      });
    }
    finally {
      setLoad(false);
    }
  }

  function getDateFromTimestamp(timestamp) {
    const date = new Date(timestamp);
    return date.toISOString().split('T')[0];
  }

  function getTimeFromTimestamp(timestamp) {
    const date = new Date(timestamp);
    return date.toISOString().split('T')[1].split('.')[0];
  }

  return (
    <>
      <div className='page page__fullBody' style={
        isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        <Header title={'Discount Requests'} isBack={false} />
        <div className='page__body'>
          <div className='tableWrap'>
            <div className='tableWrap__head'>
              <div className="formRow formRow__3 m_0 w_100 formRow--flexEnd">
                <div className='formCol'>
                  <Search
                    text="Patient Name"
                    onSearchClick={searchClick}
                    value={searchInputValue}
                    setValue={setSearchInputValue}
                  />
                </div>
                <div className='formCol'>
                  <DatePickerWithRange
                    className="px-4 py-1 rounded h-10"
                    onChange={handleDateChange}
                    startPlaceholder="From"
                    endPlaceholder="To"
                    startDate={dateRange.startDate}
                    endDate={dateRange.endDate}
                    style={{ width: '200px' }}
                  />
                </div>
                <div className="formCol">
                  <div className='btn__group relative'>
                    <button onClick={resetFilter} className="filter-button" style={{ marginLeft: '5px' }}>
                      <Icon name="ClearFilters" className="text-black cursor-pointer" width="16" height="16"></Icon>
                      Clear
                    </button>
                  </div>

                </div>
              </div>
            </div>
            <div className='tableContainer'>
              <CustomTable columns={columns} data={tableData} actions={checkCanApproveDiscount() ? actions : actions.filter(action => action.label === 'Preview Invoice')} moreActions={moreActions} searchQuery={searchQuery} from="discountNotification" userDetails={''} setClickedItem={''} clickedItem={''} />
            </div>
          </div>
        </div>
        {tableData.length > 0 && <Pagination
          onChangePage={onPageChangeHandler}
          onChangePerPage={handlePageSizeChange}
          totalPage={totalPg}
          currentPage={pgNumber}
          perPage={pgLimit}
        />}
      </div>
      <ConfirmationPopup
        isOpen={isPopupOpen}
        title={confirmationPopup.tite}
        message={confirmationPopup.message}
        onConfirm={handleConfirmApprove}
        onCancel={handleCancel}
        textField={
          <div className='mt-3'>
            <input
              className='w-full h-10 px-2'
              type="number"
              value={confirmationPopup.discount}
              onChange={(e) => setConfirmationPopup({ ...confirmationPopup, discount: e.target.value })}
              placeholder="%"
            />
          </div>
        }
      />
      <ConfirmationPopup
        isOpen={isCancelPopupOpen}
        title={confirmationPopup.tite}
        message={confirmationPopup.message}
        onConfirm={handleCancelDiscount}
        onCancel={()=> setIsCancelPopupOpen(false)}
      />
      <SuccessModal
        isSuccessModalOpen={isSuccessModalOpen}
        title={successModalText}
        handleCloseModal={() => setIsSuccessModal(false)}
      />
      <Loader isLoaderOpen={load || getInvoiceDiscountRequestData?.loading}></Loader>
    </>
  )
}

export default DiscountNotification
